<template>
  <div class="uk-grid-medium" uk-grid>
    <div class="uk-width-5-5">
      <div class="d-flex">
        <nav id="breadcrumbs" class="mb-3">
          <ul>
            <li>
              <router-link :to="{ name: 'company.dashboard' }">
                <i class="uil-home-alt"></i>
              </router-link>
            </li>
            <li>{{ $t('general.authorization') }}</li>
            <li>{{ $t('general.roles') }}</li>
          </ul>
        </nav>
      </div>

      <div class="section-header mb-lg-2 border-0 uk-flex-middle">
        <div class="section-header-left">
          <h2 class="uk-heading-line text-left">
            <span> {{ $t('general.roles') }}</span>
          </h2>
        </div>
        <div class="section-header-right">
          <router-link :to="{ name: 'company.authorization.add-edit-roles' }">
            <button class="btn btn-default" type="button" aria-expanded="false">
              <i class="uil-plus"></i> {{ $t('general.add_new_role') }}
            </button>
          </router-link>
        </div>
      </div>

      <template v-if="errorMessages">
        <div v-for="(error, index) in errorMessages" :key="index" class="uk-alert-danger" uk-alert>
          <a class="uk-alert-close" uk-close></a>
          <p style="color: red">
            <i class="uil-exclamation-triangle"></i> {{ error }}
          </p>
        </div>
      </template>
      <div v-if="successMessage" class="uk-alert-success" uk-alert>
        <a class="uk-alert-close" uk-close></a>
        <p style="color: green">
          <i class="uil-exclamation-triangle"></i> {{ successMessage }}
        </p>
      </div>
      <div class="card">
        <!-- Card header -->
        <div class="card-header actions-toolbar border-0">
          <div class="d-flex justify-content-between align-items-center">
            <div class="row" style="width:100%">
              <div class=" col-md-1  search-icon ">
                <i class="uil-search"></i>
              </div>
              <div class="col-md-11 uk-search uk-search-navbar" style="margin-left:-2rem">
                <input class="uk-search-input shadow-0 uk-form-small" type="search" v-model="filter.search"
                  :placeholder="$t('general.search')" />
              </div>
            </div>
            <sort-dropdown :sort-options="sortOption" :title="sortTitle" @sort-selected="sortOrder" />
          </div>
        </div>
        <!-- Table -->
        <div class="table-responsive">
          <table class="table align-items-center">
            <thead>
              <tr>
                <th scope="col">{{ $t('general.role_name') }}</th>
                <th scope="col"> {{ $t('general.role_type') }}</th>
                <th scope="col">{{ $t('general.authorities') }}</th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody class="list">
              <!--user item-->
              <tr v-for="role in roles">
                <th scope="row">
                  <div class="media align-items-center">
                    <div>
                      <div class="avatar-parent-child">
                        <i class="uil uil-user-circle"></i>
                      </div>
                    </div>
                    <div class="media-body ml-4">
                      {{ role.name }}
                    </div>
                  </div>
                </th>
                <td>
                  <div class="role-type">
                    <i class="uil-lock" />
                    <!-- <i class="uil-lock-open-alt" /> -->
                    {{ role.name }}
                  </div>
                </td>
                <td>{{ role.auth_count }}</td>
                <td class="text-right">
                  <div class="actions ml-3">
                    <router-link :to="{
                      name: 'company.authorization.add-edit-roles',
                      params: { id: role.id },
                    }" class="btn btn-icon btn-hover btn-sm btn-circle"
                      :uk-tooltip="$t([1, 2, 3].includes(role.id) ? 'görüntüle' : 'faq_categories.edit')">
                      <i :class="[1, 2, 3].includes(role.id) ? 'uil-eye' : 'uil-pen'"></i>
                    </router-link>
                    <a href="javascript:void(0)" class="btn btn-icon btn-hover btn-sm btn-circle"
                      :class="{ 'disabled-link': isProtectedRole(role.id) }"
                      :uk-tooltip="$t('general.delete')" title=""
                      @click="!isProtectedRole(role.id) && removeRole(role.id)"
                      :style="{ opacity: isProtectedRole(role.id) ? 0.5 : 1, cursor: isProtectedRole(role.id) ? 'not-allowed' : 'pointer' }"
                      aria-expanded="false">
                      <i class="uil-trash"></i>
                    </a>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <pagination v-if="pagination && pagination.hasOwnProperty('links')" :pagination="pagination"
          @changePage="setPage($event)"></pagination>
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/core/services";
import Pagination from "@/assets/components/Pagination";
import moment from "moment";
import SortDropdown from "@/view/components/dropdown/SortDropdown.vue";
import axios from "axios";
import Swal from "sweetalert2";
export default {
  name: "RoleList",
  components: { Pagination, SortDropdown },
  data() {
    return {
      status_id: null,
      pagination: null,
      successMessage: null,
      errorMessages: [],
      page: 1,
      per_page: 10,
      sort_by: "id",
      sort_desc: "desc",
      filter: {
        search: null,
        orderBy: "id",
        sort: "desc",
      },
      roles: [
      ],
      sortTitle: this.$t("filters.order.sort"),
      sortOption: [
        { key: 'text-asc', sort: 'id', order: 'asc', label: this.$t("sorting.a_z") },
        { key: 'text-desc', sort: 'id', order: 'desc', label: this.$t("sorting.z_a") },
        { key: 'created_at-asc', sort: 'created_at', order: 'asc', label: this.$t("sorting.created_at_asc") },
        { key: 'created_at-desc', sort: 'created_at', order: 'desc', label: this.$t("sorting.created_at_desc") },
      ],
    };
  },
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }
  },
  computed: {
    error: {
      get() {
        return false;
      },
      set(value) { },
    },
  },
  methods: {
    isProtectedRole(id) {
      const protectedRoleIds = [1, 2, 3]; // Sabit roller
      return protectedRoleIds.includes(id);
    },
    getRoles() {
      let self = this;
      axios.get(`${'api/roles'}`, {
        headers: this.apiHeaders
      }).then((result) => {
        this.roles = result.data.global;
        // result.data.company
        result.data.company.forEach(item => {
          this.roles.push(item);
        });
      });
    },
    removeRole(id) {
      Swal.fire({
        title: this.$t('general.confirm_delete_role'),
        icon: "question",
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes'),
        cancelButtonText: this.$t('general.give_up'),
        confirmButtonColor: "#e31748",
      }).then((result) => {
        if (result.isConfirmed) {
          axios.delete(`api/roles/` + id + '', {
            headers: this.apiHeaders
          }).then((result) => {
            if (!this.error) {
              this.successMessage = this.$t("general.successfully_deleted");
              this.getRoles();
            } else this.errorMessages.push(this.error);
          })
        }
      });

    },

    sortOrder(orderBy, sort, is_user = true) {
      let self = this;
      self.page = 1;
      self.filter.orderBy = orderBy;
      self.filter.sort = sort;

    },
    setPage(page, is_user = true) {
      let self = this;
      self.page = page;
    },
    resetMessages() {
      this.successMessage = null;
      this.errorMessages = [];
    },
  },
  mounted() {
    this.getRoles();
  },
  watch: {
    "filter.search": function (val) {
      this.debouncedFilterSearch();
    },
    successMessage: function (val) {
      this.debouncedResetValues();
    },
    errorMessages: function (val) {
      this.debouncedResetValues();
    },
  },
  created: function () {
    this.debouncedResetValues = _.debounce(this.resetMessages, 2000);
  },
};
</script>
<style scoped>
input[type="button"],
input[type="submit"],
span.btn,
.btn {
  display: inline-block;
}

.role-type {
  background-color: #8D8FA9;
  border-radius: 12px;
  display: inline-block;
  padding: 4px 8px;
  color: white;

  i {
    color: white !important;
  }
}

.disabled-link {
  pointer-events: none;
}
</style>
